import {
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const {
      revenueContributionByDeletedSkus,
      revenueContributionByDeletedSkusDelta,
    } = data.getPOReachMetrics;

    return createKpiTileItem(
      "Revenue Contribution by Deleted SKU's",
      formatPercentageValue(revenueContributionByDeletedSkus),
      revenueContributionByDeletedSkusDelta !== null &&
        revenueContributionByDeletedSkusDelta !== undefined
        ? {
            isPositiveValue: revenueContributionByDeletedSkusDelta >= 0,
            text: formatPercentageValue(
              Math.abs(revenueContributionByDeletedSkusDelta)
            ),
            sideLabel: '',
            showArrow: Number(revenueContributionByDeletedSkusDelta) !== 0,
          }
        : null
    );
  },
};
